/* Warenkorb-Wächter für den LPD Designer.
 *
 * Die Mengenstaffel steckt im Variantenpreis (Optionswert "Druck", z. B. "Front · ab 10").
 * Ändert jemand im Warenkorb die Menge, passt der Wächter die Zeilen dieses Motivs auf die
 * richtige Staffel an. Gruppiert wird nach der Design-Kennung, damit der Rabatt pro Motiv
 * gilt und nicht über den ganzen Warenkorb.
 *
 * Produkt und Staffel sind hier nicht mehr fest verdrahtet: Es gibt je Blank ein eigenes
 * Warenkorb-Produkt mit eigener Staffel (meist 6/10/15/20/25, beim Relax Hood nur 6/10/15).
 * Der Designer schreibt beides in die Zeile, der Wächter liest es von dort — sonst hätte er
 * bei 14 von 15 Produkten gar nicht gegriffen und beim fünfzehnten die Stufe "ab 6"
 * fälschlich auf den vollen Preis zurückgesetzt.
 *
 * Zweite Aufgabe: Das Warenkorb-Produkt muss veröffentlicht bleiben, weil die Section
 * Rendering API eine erreichbare Produktseite braucht. Damit ist es über seine Adresse
 * auch direkt kaufbar — "Front + Rücken · ab 25" ließe sich einmal ohne jedes Motiv
 * bestellen. Der Wächter stellt solche Zeilen auf "Ohne Druck" um oder entfernt sie.
 */
(function () {
  'use strict'
  var CFG = window.LPD_CART_GUARD || {}
  var onCart = /\/cart/.test(window.location.pathname)
  var KEY = CFG.designKey || '_design_id'
  var STAFFEL_KEY = '_staffel'
  var busy = false, optionIds = {}

  function normTiers(list) {
    return (list || []).map(function (t) {
      var min = typeof t === 'number' ? t : t && t.min
      return { min: min, label: (t && t.label) || ('ab ' + min) }
    }).filter(function (t) { return t.min > 0 })
      .sort(function (a, b) { return b.min - a.min })
  }
  // Die Staffel steht in jeder Zeile des Motivs. Die erste, die eine hat, entscheidet.
  // Gibt es keine, wird NICHT geraten — siehe tiersAusOptionen.
  function tiersAusZeilen(items) {
    for (var i = 0; i < items.length; i++) {
      var s = items[i].properties && items[i].properties[STAFFEL_KEY]
      if (!s) continue
      var mins = String(s).split(',').map(function (x) { return parseInt(x, 10) })
      var tiers = normTiers(mins.filter(function (x) { return x > 0 }))
      if (tiers.length) return tiers
    }
    return null
  }
  // Rueckfall ohne Raten: Die echte Leiter steht in den Optionswerten des Produkts
  // ("Front · ab 15" -> 15). loadOptionIds holt sie ohnehin und legt sie ab, es
  // kostet also keinen zusaetzlichen Abruf.
  //
  // Eine feste Ruecklage stand hier frueher — die war gefaehrlich: Das im Shop
  // laufende Skript schreibt _staffel bis heute nicht mit, also haette sie IMMER
  // gegriffen. Mit [25, 10] gegen die echte Leiter 6/10/15/20/25 bekaeme ein Kunde
  // bei 15 Stueck die Stufe "ab 10" und bei 6 Stueck gar keine — der Waechter
  // haette ihm Rabatt weggenommen, der ihm zusteht.
  function tiersAusOptionen(ids) {
    var druck = (ids && ids['Druck']) || {}
    // Jede Stufe steht dreimal drin, einmal je Druckart ("Front · ab 10",
    // "Ruecken · ab 10", "Front + Ruecken · ab 10"). Einmal genuegt.
    var gesehen = {}, mins = []
    Object.keys(druck).forEach(function (wert) {
      var m = /·\s*ab\s*(\d+)\s*$/.exec(wert)
      if (!m) return
      var n = parseInt(m[1], 10)
      if (gesehen[n]) return
      gesehen[n] = true
      mins.push(n)
    })
    var tiers = normTiers(mins)
    return tiers.length ? tiers : null
  }
  function splitDruck(v) {
    var i = v.indexOf(' · ')
    return i === -1 ? { base: v, tier: '' } : { base: v.slice(0, i), tier: v.slice(i + 3) }
  }
  function tierFor(n, tiers) {
    for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].min) return tiers[i].label
    return ''
  }
  // Zeile eines Warenkorb-Produkts, die nicht aus dem Designer kommt: Sie trägt eine
  // Option "Druck" — die gibt es nur an den Warenkorb-Produkten — aber keine
  // Design-Kennung. Es wäre also Druck bezahlt, ohne dass irgendwo steht, was gedruckt
  // werden soll.
  function ohneMotiv(it) {
    var id = it.properties && it.properties[KEY]
    if (id && String(id).indexOf('lpd_') === 0) return false
    var druck = opt(it, 'Druck')
    return !!druck && druck !== 'Ohne Druck'
  }
  // Eine Meldung überlebt das Neuladen nur im sessionStorage; direkt nach der Korrektur
  // wird die Seite ja neu geladen.
  var MELDUNG_KEY = 'lpd_guard_meldung'
  function merkeMeldung(txt) {
    try { window.sessionStorage.setItem(MELDUNG_KEY, txt) } catch (e) { /* privater Modus */ }
  }
  function zeigeMeldung() {
    var txt = null
    try { txt = window.sessionStorage.getItem(MELDUNG_KEY); window.sessionStorage.removeItem(MELDUNG_KEY) } catch (e) { return }
    if (!txt) return
    var el = document.createElement('div')
    el.setAttribute('role', 'status')
    el.style.cssText = 'margin:16px auto;max-width:900px;padding:12px 16px;border:1px solid #d8d4cd;'
      + 'border-radius:10px;background:#fbf9f6;font:14px/1.5 system-ui,sans-serif;color:#111'
    el.textContent = txt
    var ziel = document.querySelector('main') || document.body
    ziel.insertBefore(el, ziel.firstChild)
  }
  function opt(item, name) {
    var o = item.options_with_values || []
    for (var i = 0; i < o.length; i++) if (o[i].name === name) return o[i].value
    return null
  }
  // Je Handle eigene Options-IDs: die Warenkorb-Produkte sind verschiedene Produkte.
  function loadOptionIds(handle) {
    if (optionIds[handle]) return Promise.resolve(optionIds[handle])
    return fetch('/products/' + handle + '?section_id=lpd-variant-ids')
      .then(function (r) { return r.text() })
      .then(function (html) {
        var m = html.match(/data-lpd-option-ids>([\s\S]*?)<\/script>/)
        var ids = m ? JSON.parse(m[1]) : null
        if (!ids) throw new Error('option-ids')
        optionIds[handle] = ids
        return ids
      })
  }
  function resolveVariant(handle, farbe, groesse, druck) {
    return loadOptionIds(handle).then(function (ids) {
      var key = [ids['Farbe'] && ids['Farbe'][farbe], ids['Größe'] && ids['Größe'][groesse],
                 ids['Druck'] && ids['Druck'][druck]]
      if (key.some(function (x) { return !x })) throw new Error('unbekannte Option')
      return fetch('/products/' + handle + '?section_id=lpd-variant-json&option_values=' + key.join(','))
        .then(function (r) { return r.text() })
        .then(function (html) {
          var m = html.match(/data-lpd-variant>([\s\S]*?)<\/script>/)
          var v = m ? JSON.parse(m[1]) : null
          if (!v) throw new Error('Variante nicht gefunden')
          return v
        })
    })
  }

  function check(reload) {
    if (reload === undefined) reload = onCart
    if (busy) return Promise.resolve()
    return fetch('/cart.js').then(function (r) { return r.json() }).then(function (cart) {
      var groups = {}
      cart.items.forEach(function (it) {
        // Designer-Zeilen erkennt man an der Design-Kennung mit Praefix "lpd_", nicht am
        // Produkt-Handle: den gibt es je Blank einmal.
        var id = it.properties && it.properties[KEY]
        if (!id || String(id).indexOf('lpd_') !== 0) return
        ;(groups[id] = groups[id] || []).push(it)
      })
      // Zeilen des Warenkorb-Produkts ohne Motiv: auf "Ohne Druck" umstellen, sonst raus.
      var nackt = cart.items.filter(ohneMotiv)
      var fixes = []
      // Erst je Motiv die gueltige Leiter bestimmen, dann korrigieren. Laesst sie
      // sich nicht ermitteln, bleibt die Gruppe unangetastet — lieber ein
      // veralteter Staffelpreis als ein falsch berechneter.
      return Promise.all(Object.keys(groups).map(function (id) {
        var items = groups[id]
        var ausZeile = tiersAusZeilen(items)
        if (ausZeile) return { id: id, tiers: ausZeile }
        return loadOptionIds(items[0].handle).then(function (ids) {
          return { id: id, tiers: tiersAusOptionen(ids) }
        }, function () { return { id: id, tiers: null } })
      })).then(function (leitern) {
      leitern.forEach(function (l) {
        if (!l.tiers) return
        var items = groups[l.id], total = 0
        items.forEach(function (i) { total += i.quantity })
        var want = tierFor(total, l.tiers)
        items.forEach(function (it) {
          var druck = opt(it, 'Druck')
          if (!druck || druck === 'Ohne Druck') return
          var s = splitDruck(druck)
          if (s.tier !== want) fixes.push({ item: it, druck: s.base + (want ? ' · ' + want : '') })
        })
      })
      if (!fixes.length && !nackt.length) return
      busy = true
      // Nacheinander: jede Zeile mit der richtigen Variante neu anlegen und danach die
      // alte entfernen. Erst hinzufuegen, dann entfernen — andersherum waere die Zeile
      // weg, sobald das Hinzufuegen scheitert, und der Kunde verloere seine Position.
      function ersetzen(item, druck) {
        return resolveVariant(item.handle, opt(item, 'Farbe'), opt(item, 'Größe'), druck).then(function (v) {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: item.quantity, properties: item.properties }] }) })
            .then(function (r) {
              if (!r.ok) throw new Error('add')
              return entfernen(item)
            })
        })
      }
      function entfernen(item) {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }) })
      }
      var kette = nackt.reduce(function (chain, item) {
        return chain.then(function () {
          // Umstellen ist die mildere Korrektur: Der Kunde behaelt sein Textil, nur
          // ohne Druck. Gibt es die Kombination ohne Druck nicht, bleibt nur das
          // Entfernen — eine bezahlte Bestellung ohne Druckvorlage darf nicht
          // in die Produktion gehen.
          return ersetzen(item, 'Ohne Druck').then(function () {
            merkeMeldung('Eine Zeile war als bedruckte Ware angelegt, ohne dass ein Motiv dazugehört. '
              + 'Wir haben sie auf "Ohne Druck" umgestellt. Bedruckte Ware gestaltest du im Designer.')
          }, function () {
            return entfernen(item).then(function () {
              merkeMeldung('Eine Zeile war als bedruckte Ware angelegt, ohne dass ein Motiv dazugehört. '
                + 'Wir haben sie aus dem Warenkorb genommen. Bedruckte Ware gestaltest du im Designer.')
            })
          })
        })
      }, Promise.resolve())
      return fixes.reduce(function (chain, f) {
        return chain.then(function () { return ersetzen(f.item, f.druck) })
      }, kette)
        // busy in beiden Ausgaengen zuruecksetzen, sonst liefe nach der ersten Korrektur
        // jeder weitere check() sofort ins Leere.
        .then(function () { busy = false; if (reload) window.location.reload() },
              function (e) { busy = false; throw e })
      })
    }).catch(function (e) { busy = false; if (window.console) console.warn('LPD Cart-Guard:', e && e.message) })
  }

  CFG.check = check   // damit der Designer nach dem Hinzufuegen sofort nachziehen kann
  window.LPD_CART_GUARD = CFG
  if (onCart) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zeigeMeldung)
    else zeigeMeldung()
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { check(true) })
    else check(true)
  }
  // Das Theme aktualisiert den Warenkorb per Ajax. Nach jedem Cart-Request erneut pruefen.
  var origFetch = window.fetch
  window.fetch = function () {
    var a = arguments[0]
    var url = a && a.url ? a.url : String(a)
    var p = origFetch.apply(this, arguments)
    if (onCart && /\/cart\/(change|update|add)/.test(url)) p.then(function () { setTimeout(function () { check(true) }, 500) }, function () {})
    return p
  }
})()
